
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 141.3 141.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.3 0C7.8 0 0 7.8 0 17.3V124c0 9.6 7.8 17.3 17.3 17.3H124c9.6 0 17.3-7.8 17.3-17.3V17.3C141.3 7.8 133.6 0 124 0H17.3z","fill":"#c9151c"}}),_c('path',{attrs:{"d":"M73.6 26.5c-24.1 0-38.3 18-38.3 32.4 0 8.8 5.9 17.7 8.8 17.7 2.9 0 5.9 0 5.9-2.9s-5.9-5.9-5.9-14.7c0-13 14.1-23.6 29.4-23.6 13.5 0 20.6 9.4 20.6 20.6 0 14.7-7.9 26.5-17.7 26.5-5.3 0-10-3.5-8.8-8.8 1.5-6.5 2.9-5.9 5.9-17.7.9-4.1-1.2-8.8-5.9-8.8-5.3 0-11.8 4.1-11.8 11.8 0 4.7 2.9 8.8 2.9 8.8S52.4 91 51.2 95.1c-1.8 7.9-4.4 19.7-1.5 19.7s6.2-5.9 12.1-20.6c.9-2.1 2.9-8.8 2.9-8.8 1.8 3.2 9.1 5.9 14.7 5.9C95.7 91.3 106 76 106 55.9c0-15-13-29.4-32.4-29.4z","fill":"#fff"}})])
          )
        }
      }
    